import { useEffect } from 'react';

/**
 * Fades/slides in every [data-reveal] element the first time it enters the
 * viewport, staggering the transition-delay in groups of 5 by DOM order —
 * mirrors the original prototype's reveal behaviour.
 */
export function useScrollReveal(deps: readonly unknown[] = []) {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]'));
    if (elements.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );

    elements.forEach((el, i) => {
      el.style.transitionDelay = `${(i % 5) * 70}ms`;
      observer.observe(el);
    });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
